import { SubmitAction } from "../../action/Action";
import { PromiseToast } from "../../components/async/PromiseToast";
import Button from "../../components/Button/Button";
import Centered from "../../components/Centered";
import Form from "../../components/form/Form";
import type { TextFieldProps } from "../../components/form/TextField";
import TextField from "../../components/form/TextField";
import useField from "../../components/form/useField";
import Grid from "../../components/Grid";
import { callOutgoingRequest } from "../../data/tanstack-query";
import { loginAnonymous } from "../../endpoints/outgoing-requests";
import useSubmit from "../../hooks/useSubmit";

export default function AnonymousLoginScreen() {
    const idField = useField<TextFieldProps>({
        value: undefined,
        label: "Identifiant anonyme",
        required: true,
    });
    const passwordField = useField<TextFieldProps>({
        value: undefined,
        label: "Mot de passe",
        type: "password",
        required: true,
    });
    const [onSubmit, submission] = useSubmit(async (): Promise<void> => {
        const id = idField.validate();
        const password = passwordField.validate();
        await callOutgoingRequest(loginAnonymous({ id, password }));
    }, []);
    return (
        <>
            <PromiseToast promise={submission} message="Connexion réussie" />
            <Form onSubmit={onSubmit}>
                <Grid columns={1} gap={4}>
                    <TextField {...idField.props} />
                    <TextField {...passwordField.props} />
                    <Centered>
                        <Button label="Se connecter" action={SubmitAction} />
                    </Centered>
                </Grid>
            </Form>
        </>
    );
}
